import React from "react";
import { Player, ControlBar, Shortcut } from "video-react";

const IMG = (imgName) => {
    return require(`../assets/images/${imgName}`);
  };

  const AJLT = () => {
    return (
        <div className="page">
            <div className="projectPageTitle">And Just Like That x Saks Fifth Avenue</div>
            <div className="projectPageBody">
                As part of the launch campaign for season three of the HBO MAX series 'And Just Like That...', we installed
            a series of window displays at Saks Fifth Avenue's iconic flagship store in New York City. These dedicated windows offered a visually
            captivating tribute to the series, bringing together fashion, high-end design, and cutting-edge technology.
            <br/><br/>
            The windows included an interactive LED screen where guests could see themselves inside a martini glass, a kinetic shoe sculpture made out of coffee cups,
            a custom dress (made out of newspaper) that would blow as if being lifted by a subway gust when guests were detected, and a digital scene where pigoens would scatter when guests approached the screen. 
            </div>
            <div className="projectPageVideo">
                <Player
                volume={0}
                muted={true}
                playing={true}
                autoPlay={true}
                controls={false}
                loop={true}
                playsInline={true}
                src={IMG("ajlt/AJLT_Reel.mp4")}>
                <ControlBar disableCompletely={true}></ControlBar>
                <Shortcut clickable={false} />
                </Player>
            </div>
            <br/><br/>
            <img className="projectPageImg" alt="AJLT x Saks Fifth Avenue Window Hero" src={IMG("ajlt/1O2A0801.jpg")}></img>
            <br/><br/>
            <img className="projectPageImg" alt="AJLT x Saks Fifth Avenue Bag Sculpture" src={IMG("ajlt/1O2A0745.jpg")}></img>
            <br/><br/>
            <img className="projectPageImg" alt="AJLT x Saks Fifth Avenue Dress Sculpture" src={IMG("ajlt/1O2A0778.jpg")}></img>
            <br/><br/>
            <img className="projectPageImg" alt="AJLT x Saks Fifth Avenue Window Display 3Up" src={IMG("ajlt/1O2A0802 (1).jpg")}></img>
            <br/><br/> 
            <img className="projectPageImg" alt="AJLT x Saks Fifth Avenue Window Display 3Up" src={IMG("ajlt/1O2A0802 (2).jpg")}></img>
            <br/><br/>       
            </div>
    )
  };

  export default AJLT;